import React, { Component } from 'react'
import { Modal, Input, Icon, Tag, notification, Tooltip, message, Popconfirm } from "antd"
import ListItemsQC from './selectItemsQC/ListItemsQC'
import ListItemsQCError from './selectItemsQC/ListItemsQCError'
import InfoBasket from './selectItemsQC/InfoBasket'
import '../styles/index.scss'
import { getMarkInformation, getMarkInformationV3, markCompletedByOrderIdV2, markError, markCompleted1STByOrderId, getInformationBatchByNameV2, updateStatusBatchV2, forceQCHTBatchItem } from "../../../services/api/3dApi"
import { addOrderToBasket } from '../../../services/api/mergerApi'
import convertDateOverTime from '../../../helpers/convertDateOverTime'
import * as applyBrandingForAllItems from '../../../configs/applyBrandingForAllItems'
import { getBasketByItem } from '../../../services/api/basketsMergerSetApi'
import { getLocalData } from '../../../services/StorageServices'
import { parseJwt } from '../../../helpers/parseToken'

const FORCE_QCHT_STAGE_ERROR_REGEX = /không ở trạng thái|chưa đến công đoạn/i

class MarkQC extends Component {
    state = {
        loading: false,
        loadingQC1ST: false,
        error: '',
        errorInput: '',
        barCode: '',
        inputValue: '',
        basketInfo: null,
        totalItems: 0,
        allItems: [],
        oneItem: [],
        outItems: [],
        typeQC: false,
        isAddBasket: false,
        defaultChecked: [],
        relatedSkuWithInputBarcode: {},
        allSelected: false,
        selectedItem: [],
        arrCheckError: [],
        tags: [],
        error_type: 'print',
        isOpen: false,

        markResults: {
            successResult: [],
            errorResult: [],
            addedBasket: null,
        },
        isMoreThanTwoLines: false,
        itemSets: [],
        isLastItemToBasket: false,
        designRootMismatchWarning: '',
        sewingThreadColor: null,
    }

    _input = React.createRef()
    textRef = React.createRef()

    checkTextHeight = () => {
        if (this.textRef.current) {
            const lineHeight = parseFloat(
                window.getComputedStyle(this.textRef.current).lineHeight
            )
            const maxHeight = lineHeight * 2
            this.setState({
                isMoreThanTwoLines: this.textRef.current.scrollHeight > maxHeight,
            })
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { allItems, selectedItem, defaultChecked } = this.state
        if ((prevState.selectedItem !== selectedItem) && selectedItem.length > 0) {
            this.setState({
                allSelected: allItems.length === selectedItem.length + defaultChecked.length,
            })
        }
    }

    _onPaste = (e) => {
        //e.preventDefault()
    }

    _handleChange = e => {
        let { value } = e.target

        this.setState({
            error: '',
            errorInput: '',
            inputValue: value,
        })
    }

    _checkIsLastItemToBasket = async (inputValue) => {
        const itemNumber = inputValue ? inputValue.replace('#', '') : ''
        try {
            const { data: res } = await getBasketByItem(itemNumber)
            const { success, message: mess, data } = res || {}

            if (!success) {
                throw new Error(mess)
            }
            const { notCompletedCount, isLastItemInBasket } = data || {}
            if (notCompletedCount === 1 && isLastItemInBasket) return true
            return false
        } catch (error) {
            console.log('getBasketByItemError:', error.message)
            return false
        }
    }

    _onSubmit = async (e) => {
        e.preventDefault()

        const { inputValue } = this.state
        const check = /^#\d+_\d+$/.test(inputValue)

        this.setState({
            allSelected: false,
            selectedItem: [],
            arrCheckError: [],
            markResults: {
                successResult: [],
                errorResult: [],
                addedBasket: null,
            },
        })
        const newIsLastItemToBasket = inputValue ? await this._checkIsLastItemToBasket(inputValue) : false

        if (check) {
            this.setState({
                barCode: '',
                inputValue: inputValue,
                isLastItemToBasket: newIsLastItemToBasket,
            }, () => {
                const valueFormatted = inputValue.trim().replace(/^#/, '')

                if (!valueFormatted) {
                    return null
                }

                this._handleGetDataMark(valueFormatted)
            })
        } else {
            this.setState({
                barCode: '',
                errorInput: 'Item không đúng định dạng.',
            })
        }
    }

    _handleGetDataMark = async (value) => {
        this.setState({
            loading: true,
            designRootMismatchWarning: ''
        })

        this.textRef.current = null
        try {
            const { data: response } = await getMarkInformationV3(value)
            const { data, success, error } = { ...response }
            if (!success) {
                const { batch = {} } = data || {}
                const batchItemId = await this._findForceBatchItemId({ error, batch, barcode: value })
                return this.setState({
                    error: error,
                    loading: false,
                }, async () => {
                    if (batch && batch._id) {
                        try {
                            const { data: batchRes } = await getInformationBatchByNameV2({ name: batch.name })
                            const { success: batchSuccess, data: batchData } = batchRes || {}
                            const { nextStage } = (batchSuccess && batchData) || {}
                            const { name: nextStatus = '' } = nextStage || {}

                            if (['Đã may', 'Nhận may'].includes(nextStatus)) {
                                Modal.confirm({
                                    title: 'Lỗi',
                                    content: <div>
                                        <div style={{whiteSpace: 'pre-line'}}>{this.state.error}{'\n'} Bạn muốn nhận may Lô <a href={`/batches/${batch._id}`}>{batch.name}</a>?</div>
                                        {this._renderForceQCHTLink({ barcode: value, batchItemId })}
                                    </div>,
                                    okText: 'Nhận may',
                                    cancelText: 'Đóng',
                                    onOk: () => this._handleConfirmBatchSewed(batchData),
                                    onCancel: this._resetScanInput,
                                })
                            } else {
                                Modal.error({
                                    title: 'Lỗi',
                                    content: this._renderQCErrorContent({ error: this.state.error, barcode: value, batchItemId }),
                                    onOk: this._resetScanInput,
                                    okText: 'Đóng',
                                })
                            }
                        } catch (e) {
                            Modal.error({
                                title: 'Lỗi',
                                content: this._renderQCErrorContent({ error: this.state.error, barcode: value, batchItemId }),
                                onOk: this._resetScanInput,
                                okText: 'Đóng',
                            })
                        }
                    } else {
                        Modal.error({
                            title: 'Lỗi',
                            content: this._renderQCErrorContent({ error: this.state.error, barcode: value, batchItemId }),
                            onOk: this._resetScanInput,
                            okText: 'Đóng',
                        })
                    }
                })
            }

            const { barcode, can_qc_multiple_items, can_add_to_basket, basket, design_root_mismatch_warning = '', sewing_thread_color = null } = data
            const { products, relatedSkuWithInputBarcode, tags } = barcode

            //Lấy ra index của item được quét vào
            const index = value.lastIndexOf("_")
            const itemIndex = value.substr(index + 1)

            //lấy ra item theo index của item
            const oneItem = products.filter(item => item.pos === parseInt(itemIndex))
            //Lấy ra các order còn lại trừ đơn được đưa vào
            const outItem = products.filter(item => item.pos !== parseInt(itemIndex))
            //Lấy ra các item không được phép đánh dấu
            const defaultChecked = products.filter(item => {
                return !item.can_qc_completed ? item._id : null
            })

            this.setState({
                loading: false,
                basketInfo: basket,
                allItems: products,
                oneItem: oneItem,
                outItems: outItem,
                defaultChecked: defaultChecked.map(item => item._id),
                typeQC: can_qc_multiple_items,
                isAddBasket: can_add_to_basket,
                totalItems: products.length,
                relatedSkuWithInputBarcode: relatedSkuWithInputBarcode,
                tags: tags,
                barcode,
                designRootMismatchWarning: design_root_mismatch_warning,
                sewingThreadColor: sewing_thread_color,
            },
                () => {
                    const { oneItem: oneSelect, typeQC } = this.state
                    const { meta = {}, tool3d_order = {} } = oneSelect[0] || {}
                    const { set_items = [] } = meta
                    const newSetItems = set_items.map(set => ({
                        ...set,
                        checked: false
                    })) || []
                    this.checkTextHeight()

                    if (!typeQC) {
                        this.setState({
                            selectedItem: [tool3d_order._id],
                            itemSets: newSetItems
                        })
                    }
                },
            )
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false,
            })
        }
    }

    _resetScanInput = () => {
        this.setState({
            loading: false,
            error: '',
            barCode: '',
            inputValue: '',
            basketInfo: null,
            totalItems: 0,
            arrChecked: [],
            allSelected: false,
            allItems: [],
            oneItem: [],
            outItems: [],
            typeQC: false,
            isAddBasket: false,
            selectedItem: [],
            arrCheckError: [],
            tags: [],
            error_type: 'print',
            isOpen: false,
            relatedSkuWithInputBarcode: {},
            markResults: {
                successResult: [],
                errorResult: [],
                addedBasket: null,
            },
            isMoreThanTwoLines: false,
            barcode: {},
            itemSets: [],
            isLastItemToBasket: false,
            sewingThreadColor: null,
        }, () => {
            this._input.current.focus()
        })
    }

    _handleConfirmBatchSewed = async (batchData) => {
        try {
            const { batch: batchInfo, nextStage } = batchData || {}
            const { name: nextStatus = '' } = nextStage || {}
            const { _id: batchId, name: batchName, partner: partnerSewingId } = batchInfo || {}

            if (!batchId || !batchName) {
                throw new Error('Không tìm thấy thông tin lô')
            }

            const tokenData = getLocalData('accessToken')
            const { username = '' } = parseJwt(tokenData)

            const payload = {
                partner: partnerSewingId,
                status: nextStatus,
                batchIds: [batchId],
            }
            if (nextStatus === 'Đã may') {
                const { data: res2 } = await updateStatusBatchV2(payload)
                const { success: success2, error: error2 } = res2 || {}
                if (!success2) {
                    throw new Error(`Lô ${batchName}: ${error2 || 'Cập nhật trạng thái đã may không thành công'}`)
                }

                const { data: batchRes } = await getInformationBatchByNameV2({ name: batchName })
                const { success: batchSuccess, data: newBatchData } = batchRes || {}
                if (!batchSuccess) {
                    throw new Error(`Lô ${batchName}: Đã chuyển sang "Đã may" nhưng không lấy được thông tin tiếp theo. Vui lòng kiểm tra lô trên trang quản lý lô.`)
                }
                const { nextStage: newNextStage } = newBatchData || {}
                const { name: newNextStatus = '' } = newNextStage || {}
                if (newNextStatus !== 'Nhận may') {
                    throw new Error(`Lô ${batchName}: Đã chuyển sang "Đã may" nhưng trạng thái tiếp theo không hợp lệ (${newNextStatus || 'không xác định'}). Vui lòng kiểm tra lô trên trang quản lý lô.`)
                }
                payload.status = newNextStatus
            }
            if (nextStatus === 'Nhận may' || payload.status === 'Nhận may') {
                payload.receive_sew_name = username
            }

            const { data: res } = await updateStatusBatchV2(payload)
            const { success: updateSuccess, data: updateData, error: updateError } = res || {}
            if (!updateSuccess) {
                const prefix = nextStatus === 'Đã may' ? `Lô ${batchName}: Đã chuyển sang "Đã may" nhưng chuyển "Nhận may" thất bại` : 'Cập nhật trạng thái lô không thành công'
                throw new Error(updateError || prefix)
            }
            const { message: mess } = updateData || {}
            message.success(mess || 'Cập nhật trạng thái lô thành công')
            Modal.destroyAll()
        } catch (err) {
            message.error(err.message)
        } finally {
            this._resetScanInput()
        }
    }

    _canForceQCHT = () => {
        const { roles = [] } = parseJwt(getLocalData('accessToken')) || {}
        return Array.isArray(roles) && roles.some(item => ['fac_admin', 'Super Admin'].includes(item.name))
    }

    _getBatchItemIdFromBatch = (batch, barcode) => {
        const { production_times: productionTimes = [] } = batch || {}
        if (!Array.isArray(productionTimes)) return ''

        const itemBarcode = `${barcode || ''}`.trim().replace(/^#/, '')
        // production_times[].item là batch item id
        const { item: batchItemId = '' } = productionTimes.find(p => p && p.barcode === itemBarcode) || {}

        return batchItemId
    }

    // API quét v1 không check công đoạn, trả order kèm batch (có production_times) để lấy batch item id
    _getBatchItemIdByScanV1 = async (barcode) => {
        try {
            const itemBarcode = `${barcode || ''}`.trim().replace(/^#/, '')
            const { data: res } = await getMarkInformation(itemBarcode)
            const { success, data: orders } = res || {}
            if (!success || !Array.isArray(orders)) return ''

            const scannedOrder = orders.find(order => order && `${order.marketplace}_${order.item_number}` === itemBarcode)
            const { batch: orderBatch } = scannedOrder || {}

            return this._getBatchItemIdFromBatch(orderBatch, itemBarcode)
        } catch (e) {
            console.log('getBatchItemIdByScanV1Error:', e.message)
            return ''
        }
    }

    _findForceBatchItemId = async ({ error, batch, barcode }) => {
        if (!this._canForceQCHT()) return ''

        // Lỗi công đoạn ("không ở trạng thái [...]", "chưa đến công đoạn...") -> API v3 không trả batch, dùng luôn API quét v1
        if (FORCE_QCHT_STAGE_ERROR_REGEX.test(`${error || ''}`)) return this._getBatchItemIdByScanV1(barcode)

        return this._getBatchItemIdFromBatch(batch, barcode) || this._getBatchItemIdByScanV1(barcode)
    }

    _handleForceQCHT = async ({ barcode, batchItemId }) => {
        // Popconfirm antd 3 không có loading cho nút OK -> chặn bấm lặp bằng cờ instance
        if (this._isForcingQCHT) return
        this._isForcingQCHT = true
        const hideLoading = message.loading('Đang ép buộc QC hoàn thành...', 0)

        try {
            const { data: res } = await forceQCHTBatchItem(batchItemId)
            const { success, data, error } = res || {}
            if (!success) {
                throw new Error(error || 'Ép buộc QC hoàn thành không thành công')
            }

            const { barcode: itemBarcode, basket_error: basketError } = data || {}
            message.success(`Đã ép buộc QC hoàn thành item ${itemBarcode || barcode}`)
            if (!!basketError) message.error(`Lỗi tạo giỏ, ${basketError}`)

            Modal.destroyAll()
            this._resetScanInput()
        } catch (err) {
            const { response } = err || {}
            const isForbidden = response && response.status === 403
            message.error(isForbidden ? 'Bạn không có quyền ép buộc QC hoàn thành' : err.message)
        } finally {
            hideLoading()
            this._isForcingQCHT = false
        }
    }

    _renderForceQCHTLink = ({ barcode, batchItemId }) => {
        if (!batchItemId || !this._canForceQCHT()) return null

        return (
            <div className="mt-2">
                <Popconfirm
                    placement="top"
                    icon={<Icon type="question-circle" style={{ color: 'red' }}/>}
                    title="Bạn chắc chắn muốn đánh dấu hoàn thành với item chưa đi đủ các công đoạn cần có?"
                    okText="Yes"
                    cancelText="Hủy"
                    onConfirm={() => this._handleForceQCHT({ barcode, batchItemId })}
                >
                    <span className="text-primary cursor-pointer">
                        Bấm vào đây nếu muốn ép buộc QCHT?
                    </span>
                </Popconfirm>
            </div>
        )
    }

    _renderQCErrorContent = ({ error, barcode, batchItemId }) => (
        <div>
            <div>{error}</div>
            {this._renderForceQCHTLink({ barcode, batchItemId })}
        </div>
    )

    _updateOrdersSelected = (id, isAdded) => {
        const { selectedItem, defaultChecked, allItems } = this.state

        if (selectedItem.length + defaultChecked.length === allItems.length) {
            this.setState({
                allSelected: true,
            })
        } else {
            this.setState({
                allSelected: false,
            })
        }

        if (isAdded) {
            if (!selectedItem.includes(id)) {
                this.setState({
                    selectedItem: [...selectedItem, id],
                    allSelected: selectedItem.length + 1 === selectedItem.length,
                })
            }
        } else {
            const filtered = selectedItem.filter(orderId => orderId !== id)

            this.setState({
                selectedItem: filtered,
                allSelected: false,
            })
        }
    }

    _handleCheckError = (id, isAdded) => {
        const { arrCheckError } = this.state

        if (isAdded) {
            if (!arrCheckError.includes(id)) {
                this.setState({
                    arrCheckError: [...arrCheckError, id],
                })
            }
        } else {
            const filtered = arrCheckError.filter(orderId => orderId !== id)

            this.setState({
                arrCheckError: filtered,
                allSelected: false,
            })
        }
    }

    _toggleSelectAll = (isChecked) => {

        this.setState(() => {
            const { allItems } = this.state

            if (isChecked) {
                const orderIds = allItems.filter(order => order.can_qc_completed).map(item => item.tool3d_order._id)

                return {
                    selectedItem: orderIds,
                    allSelected: true,
                    arrCheckError: []
                }
            }

            return {
                selectedItem: [],
                allSelected: false,
            }
        })
    }

    _toggleSelectAllError = (isChecked) => {
        this.setState(() => {
            if (isChecked) {
                const { markResults } = this.state
                const { errorResult } = markResults
                const orderIds = errorResult.map(item => item.order._id)

                return {
                    selectedItem: orderIds,
                    allSelected: true,
                }
            }

            return {
                selectedItem: [],
                allSelected: false,
            }
        })
    }

    _cancelQC = () => {
        this.setState({
            loading: false,
            error: '',
            barCode: '',
            inputValue: '',
            basketInfo: null,
            totalItems: 0,
            allItems: [],
            oneItem: [],
            outItems: [],
            typeQC: false,
            isAddBasket: false,
            defaultChecked: [],

            allSelected: false,
            selectedItem: [],
            tags: [],

            markResults: {
                successResult: [],
                errorResult: [],
                addedBasket: null,
            },
            isMoreThanTwoLines: false,
            barcode: {},
            itemSets: [],
            sewingThreadColor: null,
        }, () => {
            this._input.current.focus()
        })
    }

    _submitQC = async () => {
        const { selectedItem, inputValue, barCode, barcode, arrCheckError, allItems, oneItem, itemSets = [], designRootMismatchWarning = '' } = this.state
        const [scannedItem] = Array.isArray(oneItem) ? oneItem : [oneItem]
        const { tool3d_order: scannedOrder = {} } = scannedItem || {}
        // Chỉ cho force khi đang QC đúng 1 item là item được quét -> tránh force nhầm item khi lỗi thuộc item khác đang được chọn
        const isOnlyScannedItemSelected = !!scannedOrder && selectedItem.length === 1 && selectedItem[0] === scannedOrder._id
        const scannedBatchItemId = isOnlyScannedItemSelected && scannedOrder.batch_item ? scannedOrder.batch_item._id : ''
        const listGIFTBOX_0700NO = allItems.length > 0 ? allItems.filter(i => i.type === 'GIFTBOX_0700NO' && i.can_qc_completed) : []
        const listBOX_0700NO = allItems.length > 0 ? allItems.filter(i => i.type === 'BOX_0700NO' && i.can_qc_completed) : []
        const listGIFTCARD_1800NO = allItems.length > 0 ? allItems.filter(i => i.type === 'GIFTCARD_1800NO' && i.can_qc_completed) : []
        const listIdGIFTBOX_0700NO = listGIFTBOX_0700NO.length > 0 ? listGIFTBOX_0700NO.map(i => i.tool3d_order._id) : []
        const listIdBOX_0700NO = listBOX_0700NO.length > 0 ? listBOX_0700NO.map(i => i.tool3d_order._id) : []

        // const listIdGIFTCARD_1800NO = listGIFTCARD_1800NO.length > 0 ? listGIFTCARD_1800NO.map(i => i.tool3d_order._id) : []
        // const listBarcodeGIFTBOX_0700NO = allItems.length > 0 ? allItems.filter(i => i.type === 'GIFTBOX_0700NO').map(i => `${i.tool3d_order.barcode_number}_${i.tool3d_order.item_number}`) : []
        const newBarCode = barCode ? barCode : inputValue
        if (selectedItem.length === 0) {
            return this.setState({
                error: 'Chọn những đơn muốn quét QC',
            })
        }

        const set_items = itemSets.filter(set => set.checked).map(o => ({ _id: o._id, name: o.name })) || []

        this.setState({
            loading: true,
            error: '',
            inputValue: '',
            barCode: newBarCode,
        })

        try {
            const listItemOtherSelect = allItems.filter(i => {
                const { type, can_qc_completed, cannot_qc_completed_reason, tool3d_order = {} } = Object.assign({}, i)
                const { _id: idItem } = { ...tool3d_order }
                return !['GIFTBOX_0700NO', 'BOX_0700NO'].includes(type) && can_qc_completed && !cannot_qc_completed_reason && !selectedItem.includes(idItem)
            }) || []
            const isAutoQcBox = listItemOtherSelect.every(i => ['THANK_CARD', 'BRAND_KIT', 'GIFTBOX_0700NO', 'GIFTCARD_1800NO'].includes(i.type))

            const payload = {
                order_ids: isAutoQcBox ? [...new Set([...selectedItem, ...listIdGIFTBOX_0700NO, ...listIdBOX_0700NO])] : selectedItem
            }

            if (!!set_items.length) payload.set_items = set_items
            if (!!designRootMismatchWarning) payload.replace_production_file = true

            const { data: response } = await markCompletedByOrderIdV2(payload)
            const hasGiftBox = listGIFTBOX_0700NO && listGIFTBOX_0700NO.length
            const hasBrandBox = listBOX_0700NO && listBOX_0700NO.length
            const hasGiftCard = listGIFTCARD_1800NO && listGIFTCARD_1800NO.length
            const hasThankCardOrBrandKit = allItems.length > 0 && allItems.some(i => ['THANK_CARD', 'BRAND_KIT'].includes(i.type) && i.can_qc_completed)
            const { success, data, error } = response

            if (!success) {
                return this.setState({
                    error: error,
                    loading: false,
                }, () => {
                    Modal.error({
                        title: 'Lỗi',
                        content: this._renderQCErrorContent({ error, barcode: newBarCode, batchItemId: scannedBatchItemId }),
                        onOk: this._resetScanInput,
                        okText: 'Đóng',
                    })
                })
            }

            const { successOrders, failedOrders, addedBasket, addedBasketError = '' } = data
            if (!!addedBasketError) message.error(`Lỗi tạo giỏ, ${addedBasketError}`)

            this.setState({
                error: '',
                loading: false,
                selectedItem: [],
                tags: [],
                oneItem: [],
                outItems: [],
                allSelected: false,
                // allItems: [],
                // arrCheckError: [],
                relatedSkuWithInputBarcode: {},
                markResults: {
                    successResult: successOrders,
                    errorResult: failedOrders,
                    addedBasket: addedBasket !== undefined ? addedBasket : null,
                },
                isLastItemToBasket: false,
                designRootMismatchWarning: ""
            }, async () => {
                if (addedBasket !== undefined) {
                    Modal.info({
                        title: '',
                        icon: null,
                        okText: 'Đóng',
                        width: 1260,
                        content: (
                            <div className="mt-3">
                                <InfoBasket
                                    addedBasket={addedBasket}
                                    barcode={barcode}
                                    onClose={() => {
                                        Modal.destroyAll()
                                        if (arrCheckError.length > 0 && arrCheckError.length < allItems.length) return this._onOpenModal()
                                        this.setState({
                                            allItems: [],
                                        })
                                        this._input.current.focus()
                                    }}
                                />
                            </div>
                        ),
                        onOk: () => {
                            if (arrCheckError.length > 0 && arrCheckError.length < allItems.length) return this._onOpenModal()
                            this.setState({
                                allItems: [],
                            })
                        },
                    })
                } else {
                    if (successOrders && successOrders.length > 0 && (hasGiftBox || hasGiftCard || hasBrandBox || hasThankCardOrBrandKit)) {
                        const dataBasket = []
                        for (let i = 0; i < successOrders.length; i++) {
                            const order = successOrders[i]
                            if (order.order) {
                                try {
                                    const { data: response } = await addOrderToBasket(`${order.order.barcode_number}_${order.order.item_number}`)
                                    if (response.success && response.data) {
                                        dataBasket.push(response.data)
                                    }
                                } catch (error) {
                                    console.log(error.message)
                                }
                            }
                        }

                        if (dataBasket && dataBasket.length > 0 && dataBasket[dataBasket.length - 1]) {
                            Modal.info({
                                title: '',
                                icon: null,
                                okText: 'Đóng',
                                width: 1260,
                                content: (
                                    <div className="mt-3">
                                        <InfoBasket
                                            addedBasket={dataBasket[dataBasket.length - 1]}
                                            barcode={barcode}
                                            onClose={() => {
                                                Modal.destroyAll()
                                                if (arrCheckError.length > 0 && arrCheckError.length < allItems.length) return this._onOpenModal()
                                                this.setState({
                                                    allItems: [],
                                                })
                                                this._input.current.focus()
                                            }}
                                        />
                                    </div>
                                ),
                                onOk: () => {
                                    if (arrCheckError.length > 0 && arrCheckError.length < allItems.length) return this._onOpenModal()
                                    this.setState({
                                        allItems: [],
                                    })
                                },
                            })
                        }
                    }
                    this.setState({
                        allItems: [],
                    })
                }
                this._input.current.focus()
            })


        } catch (e) {
            this.setState({
                loading: false,
            }, () => {
                Modal.error({
                    title: 'Lỗi',
                    content: this._renderQCErrorContent({ error: e.message, barcode: newBarCode, batchItemId: scannedBatchItemId }),
                    onOk: this._resetScanInput,
                    okText: 'Đóng',
                })
            })
        }
    }

    _submitQC1ST = async () => {
        const { selectedItem, inputValue, barCode, itemSets = [] } = this.state
        const newBarCode = barCode ? barCode : inputValue
        const set_items = itemSets.filter(set => set.checked).map(o => ({ _id: o._id, name: o.name })) || []

        if (selectedItem.length === 0) {
            return this.setState({
                error: 'Chọn những đơn muốn quét QC lần 1',
            })
        }

        this.setState({
            loadingQC1ST: true,
            error: '',
            inputValue: '',
            barCode: newBarCode,
        })

        try {
            const payload = { order_ids: selectedItem }

            if (!!set_items.length) payload.set_items = set_items

            const { data: response } = await markCompleted1STByOrderId(payload)

            const { success, data, error } = response

            if (!success) {
                return this.setState({
                    error: error,
                    loadingQC1ST: false,
                }, () => {
                    Modal.error({
                        title: 'Lỗi',
                        content: error,
                        onOk: this._resetScanInput,
                        okText: 'Đóng',
                    })
                })
            }

            this.setState({
                error: '',
                loadingQC1ST: false,
                allItems: [],
                selectedItem: [],
                tags: [],
                oneItem: [],
                outItems: [],
                allSelected: false,
                barCode: '',
            }, () => {
                Modal.success({
                    title: 'Đánh dấu QC hoàn thành lần 1 thành công',
                    okText: 'Đóng ',
                    content: `Item ${newBarCode} đã được đánh dấu QC hoàn thành lần 1`,
                })
                this._input.current.focus()
            })


        } catch (e) {
            this.setState({
                loadingQC1ST: false,
            }, () => {
                Modal.error({
                    title: 'Lỗi',
                    content: e.message,
                    onOk: this._resetScanInput,
                    okText: 'Đóng',
                })
            })
        }
    }

    _onMarkItemError = async () => {
        this.setState({
            loading: true,
            error: '',
        })

        try {
            const { allItems, arrCheckError, inputValue } = this.state
            const listSelectedError = allItems.filter(item => item.hasOwnProperty('tool3d_order') && arrCheckError.includes(item.tool3d_order._id))
            const promises = listSelectedError.map(async res => {
                const payload = {
                    error_type: res.error_type || 'print',
                    error_procedure: 'qc_completed'
                }

                const { tool3d_order } = { ...res }
                const id = tool3d_order.hasOwnProperty('batch_item') && tool3d_order.batch_item._id

                const { data: response } = await markError(id, payload)
                return response
            })

            const data = await Promise.all(promises)

            const isSuccess = data.every(item => item.success)
            const { message } = { ...data.find(item => !item.success) } || {}

            if (!isSuccess) {
                return this.setState({
                    loading: false,
                    error: message
                }, () => {
                    this._onCloeModal()

                    notification.error({
                        message: 'Đánh dấu lỗi không thành công',
                        description: `Bạn đã đánh dấu lỗi cho item ${inputValue} không thành công`,
                    })
                })
            }

            this.setState({
                loading: false,
                error: '',
                allItems: [],
                arrCheckError: [],
                inputValue: '',
                tags: [],
                oneItem: [],
                outItems: [],
                basketInfo: null,
            }, () => {
                notification.success({
                    message: 'Đánh dấu lỗi thành công',
                    description: `Bạn đã đánh dấu lỗi cho item ${inputValue} thành công`,
                })
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            }, () => {
                this._onCloeModal()
                notification.error({
                    message: 'Đánh dấu lỗi không thành công',
                    description: e.message,
                })
            })
        }
    }

    _onCloeModal = () => {
        this.setState({
            loading: false,
            isOpen: false,
            error_type: 'print',
        })
    }

    _onOpenModal = () => {
        this.setState({
            isOpen: true,
        })
    }

    _handleChangeRadio = (e, product) => {
        const { value } = e.target
        const { allItems } = this.state
        const newAllItems = allItems.map(item => {
            if (item.hasOwnProperty('tool3d_order') && item.tool3d_order.hasOwnProperty('_id') && product.hasOwnProperty('tool3d_order') &&
                item.tool3d_order._id === product.tool3d_order._id) {
                return {
                    ...item,
                    error_type: value
                }
            }
            return item
        })
        this.setState({
            allItems: newAllItems
        })
    }

    _handleChangeItemSet = (checked, setId) => {
        const { itemSets = [] } = this.state
        const newItemSets = itemSets.map(set => {
            if (set._id === setId) {
                return {
                    ...set,
                    checked
                }
            }

            return set
        })

        this.setState({
            itemSets: newItemSets
        })
    }

    render() {
        const {
            loading,
            loadingQC1ST,
            basketInfo,
            inputValue,
            barCode,
            markResults,
            totalItems,
            allItems,
            selectedItem,
            typeQC,
            outItems,
            oneItem,
            defaultChecked,
            allSelected,
            isAddBasket,
            error,
            errorInput,
            relatedSkuWithInputBarcode,
            tags,
            isOpen,
            arrCheckError,
            barcode,
            isMoreThanTwoLines,
            itemSets,
            isLastItemToBasket,
            designRootMismatchWarning,
            sewingThreadColor,
        } = this.state
        const { successResult, errorResult } = markResults
        const [orderItem] = Array.isArray(oneItem) ? [...oneItem] : [oneItem]
        const isSpecialTag = orderItem && orderItem.tags && Array.isArray(orderItem.tags) && orderItem.tags.includes('priority-store')
        const isGiftTag = Array.isArray(tags) && tags.includes('gift')
        const isSampleTag = Array.isArray(tags) && tags.includes('sample')
        const isFbaTag = Array.isArray(tags) && (tags.includes('FBA') || tags.includes('fba'))
        const isFastShipTag = Array.isArray(tags) && tags.includes('fastship')
        const brandKitItems = allItems && Array.isArray(allItems) ? allItems.filter(item => item.type === "BRAND_KIT") : []
        const isMultipleBrandingItems = applyBrandingForAllItems.isSupport(barcode)
        const isFastProductionTag = Array.isArray(tags) && tags.includes('fastproduction')
        const isTikTokTag = Array.isArray(tags) && tags.includes('tiktok')
        const isCutoffTag = Array.isArray(tags) && tags.includes('cutoff')
        const isCutOffNoel = Array.isArray(tags) && tags.includes('cutoff_noel')
        const isCutOffNewYear = Array.isArray(tags) && tags.includes('cutoff_new_year')
        const CAPTYPES = ['SNAP_CAP_13', 'TRUCKER_CAP_13', 'BASEBALL_CAP_13', 'EMBROIDERED_CAP']
        const isCapTag = Array.isArray(tags) && tags.includes('cap_product') && CAPTYPES.includes(orderItem.type)
        const isMadeInVN = Array.isArray(tags) && tags.includes('made_vn')
        const { storename, note: noteOrder = '' } = { ...barcode }
        const { is_cheap_product: isCheapProduct } = relatedSkuWithInputBarcode || {}
        const isSLL = Array.isArray(tags) && tags.includes('SLL')
        const isRndTest = Array.isArray(tags) && tags.includes('rnd_test')
        const is24hTag = Array.isArray(tags) && tags.includes('24h')

        return (
            <div className="BatchesQcPage p-5" style={{ position: 'relative' }}>
                {
                    isLastItemToBasket &&
                    <div className='px-3 py-2' style={{ position: 'absolute', top: 0, border: '2px solid', borderRadius: 10, color: '#dc3545' }}>
                        <h5 className='mb-0' style={{ color: '#dc3545' }}>Đơn ghép: Để riêng IT lấy (sau QC xong)</h5>
                    </div>
                }
                <div className="row">
                    <div className="col-5 mx-auto">
                            {
                                !!designRootMismatchWarning && 
                                <span className='mb-0 font-weight-bold' style={{ color: '#dc3545', fontSize: 15 }}>{designRootMismatchWarning}</span>
                            }
                        <div className="d-flex justify-content-between align-items-baseline">
                            <h1 className='d-flex align-items-center flex-wrap'>
                                <span className='mr-4 mb-2'>QC hoàn thành</span>
                                {isMadeInVN && typeQC &&
                                    <span className="tagVN mr-2 my-1">Made in VN</span>
                                }
                                {isCapTag && <span className="cap-tag mr-2 my-1">Sản phẩm Mũ</span>}
                                {
                                    isSpecialTag &&
                                    <Tag color="#ff0000" className="mr-2 my-1">Đặc biệt</Tag>
                                }
                                {
                                    !!brandKitItems.length &&
                                    <Tag color="#108ee9" className="mr-2 my-1">Đơn có Brand Kit</Tag>
                                }
                                {
                                    isGiftTag && <Tag color="#ff0000" className="mr-2 my-1">Hàng tặng</Tag>
                                }

                                {
                                    isSampleTag && <Tag color="#ff0000" className="mr-2 my-1">Hàng mẫu</Tag>
                                }

                                {
                                    isFbaTag && <Tag color="#ff0000" className="mr-2 my-1">FBA</Tag>
                                }

                                {
                                    isFastShipTag && <Tag color="#ff0000" className="mr-2 my-1">Ship nhanh</Tag>
                                }
                                {!!isCheapProduct &&
                                    <Tag color="#ff0000" className="mr-2 my-1">SP giá rẻ</Tag>
                                }
                                {!!isSLL &&
                                    <Tag color="#fdb813" className="mr-2 my-1">SLL</Tag>
                                }
                                {isRndTest && <Tag color="#ff0000" className="mr-2 my-1">HÀNG TEST RND</Tag>}
                            </h1>
                            <div className="bakestInfo">

                                {
                                    (basketInfo !== null && basketInfo !== undefined) && (
                                        <div>
                                            Số giỏ:
                                            <h4>
                                                <span className="BasketNumber text-danger">{basketInfo.number}</span>
                                                <span className="TotalItems"> / {basketInfo.total_items}</span>
                                            </h4>
                                        </div>
                                    )

                                }
                            </div>
                            {!!orderItem && !!orderItem.overtime && orderItem.overtime > 0 &&
                                <h4
                                    className="mb-0 mt-2 btn"
                                    style={{
                                        background: 'rgba(255 77 80)',
                                        color: 'white', cursor: 'auto',
                                    }}
                                >
                                    QUÁ HẠN <label
                                        className="font-weight-bold my-0">{convertDateOverTime(orderItem.overtime)}</label>
                                </h4>
                            }
                            {!!orderItem && !!orderItem.remaining_time && (orderItem.remaining_time > 0 && orderItem.remaining_time <= 1.5) &&
                                <h4
                                    className="mb-0 mt-2 btn"
                                    style={{
                                        background: '#ffcd3a',
                                        color: 'white', cursor: 'auto',
                                    }}
                                >
                                    Sắp quá hạn <label
                                        className="font-weight-bold my-0">{convertDateOverTime(-orderItem.remaining_time)}</label>
                                </h4>
                            }
                        </div>
                        {
                            isMultipleBrandingItems &&
                            <p className="alert alert-danger mb-4" data-context="MarkQC">BrandKit theo item</p>
                        }
                        <div className="position-relative">
                            <form onSubmit={this._onSubmit} className="formQC">
                                <Input onPaste={this._onPaste}
                                    onChange={this._handleChange}
                                    placeholder="Nhập item cần đánh dấu"
                                    style={{ fontSize: 40, height: "auto" }}
                                    value={inputValue} ref={this._input} autoFocus />
                                {
                                    loading && (
                                        <Icon type="sync" spin className="position-absolute IconInput" />
                                    )
                                }

                                {
                                    (inputValue && !loading) && (
                                        <Icon type="close-circle"
                                            className="position-absolute cursor-pointer IconInput"
                                            onClick={this._resetScanInput}
                                        />
                                    )
                                }
                            </form>
                        </div>

                        {errorInput && errorInput !== '' && <div className="text-danger mt-3">{errorInput}</div>}

                        {
                            errorResult && error !== '' && <div className="text-danger mt-3 font-18">{error}</div>
                        }

                        <div>
                            <div className="results d-flex align-items-baseline">
                                <div
                                    className={`d-flex align-items-center ${barCode || successResult.length > 0 || errorResult.length > 0 ? 'mt-3' : ''}`}>
                                    {
                                        barCode && (
                                            <span className="d-flex align-items-center mr-3"><h3
                                                className="mr-3">{barCode}</h3> Đã đánh dấu <strong
                                                    className="mx-1">{successResult.length + errorResult.length}</strong> barcode</span>
                                        )
                                    }
                                    {
                                        successResult.length > 0 && (
                                            <div className="mr-3"><i className="fa fa-check text-success mr-1" />
                                                <strong>{successResult.length}</strong> items thành công</div>
                                        )
                                    }
                                    {
                                        errorResult.length > 0 && (
                                            <div className="text-danger fontSize20"><i
                                                className="fa fa-times-circle mr-1" />
                                                <strong>{errorResult.length}</strong> items lỗi</div>
                                        )
                                    }
                                </div>
                            </div>

                            {
                                errorResult.length > 0 && (
                                    <ListItemsQCError
                                        dataMarkError={errorResult}
                                        arrChecked={selectedItem}
                                        updateOrdersSelected={this._updateOrdersSelected}
                                        toggleSelectAll={this._toggleSelectAllError}
                                        cancelQC={this._cancelQC}
                                        submitQC={this._submitQC}
                                        submitQC1ST={this._submitQC1ST}
                                        loading={loading}
                                    />
                                )
                            }
                        </div>
                    </div>
                    <div className="col-7">
                        {
                            !!noteOrder &&
                            <h1
                                className='text-danger mr-3 position-absolute'
                                ref={this.textRef}
                                style={{
                                    top: (storename === 'mt80szd' && isFastProductionTag && isTikTokTag && (isCutoffTag || isCutOffNoel || isCutOffNewYear)) ? '99px' : '80px',
                                    fontSize: '25px',
                                    cursor: isMoreThanTwoLines ? 'pointer' : 'unset',
                                    zIndex: 2
                                }}
                            >
                                {
                                    isMoreThanTwoLines ?
                                        <Tooltip title={noteOrder}>
                                            Note: {`${noteOrder.slice(0, 70)}...`}
                                        </Tooltip> :
                                        `Note: ${noteOrder}`
                                }
                            </h1>
                        }
                        <div className="d-flex SpecialTag w-100 align-items-baseline" style={{ top: 5 }}>
                            {storename === 'mt80szd' &&
                                <h2 className='text-danger mr-3'>Sản phẩm VIP - QC, đóng gói tách riêng</h2>
                            }
                            <div className="d-flex">
                                {isFastProductionTag &&
                                    <span className='mr-3'>Sản xuất nhanh</span>
                                }
                                {isTikTokTag &&
                                    <span className='mr-3 tiktok'>TIKTOK</span>
                                }
                                {is24hTag &&
                                    <span className='mr-3 tiktok'>24H</span>
                                }
                                {isCutoffTag &&
                                    <span className='mr-3'>Cutoff</span>
                                }
                                {isCutOffNoel &&
                                    <span className='mr-3'>Cutoff noel</span>
                                }
                                {isCutOffNewYear &&
                                    <span className='mr-3'>Cutoff new year</span>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <ListItemsQC
                    isAddBasket={isAddBasket}
                    totalItems={totalItems}
                    outItems={outItems}
                    allItems={allItems}
                    typeQC={typeQC}
                    oneItem={oneItem}
                    selectedItem={selectedItem}
                    defaultChecked={defaultChecked}
                    allSelected={allSelected}
                    foundBasket={basketInfo !== null && basketInfo !== undefined}
                    loading={loading}
                    loadingQC1ST={loadingQC1ST}
                    inputValue={inputValue}
                    updateOrdersSelected={this._updateOrdersSelected}
                    toggleSelectAll={this._toggleSelectAll}
                    cancelQC={this._cancelQC}
                    submitQC={this._submitQC}
                    submitQC1ST={this._submitQC1ST}
                    reset={this._resetScanInput}
                    relatedSkuWithInputBarcode={relatedSkuWithInputBarcode}
                    handleCheckError={this._handleCheckError}
                    arrCheckError={arrCheckError}
                    onMarkItemError={this._onMarkItemError}
                    onCloeModal={this._onCloeModal}
                    onOpenModal={this._onOpenModal}
                    isOpen={isOpen}
                    handleChangeRadio={this._handleChangeRadio}
                    storename={storename}
                    itemSets={itemSets}
                    onChangeItemSet={this._handleChangeItemSet}
                    designRootMismatchWarning={designRootMismatchWarning}
                    sewingThreadColor={sewingThreadColor}
                />

            </div>
        )
    }
}

export default MarkQC
